import enErrorCodes from '~/languages/errors/en';

export const getErrorCode = (code: string) => {
    const errorCode = enErrorCodes[code];

    if (!errorCode) return 'general_error';
    return code;
};
